import './styles/globals.css';
import { setTheme } from '@kk/ui/hooks/useTheme';
import i18n, { initI18n } from '@kk/ui/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { resources } from '@/locales/resources';
import App from './App';

// bootstrap 👞
(async function main() {
  if (import.meta.env.MODE === 'mock') {
    const { failOnUnhandledApiRequest, worker } = await import(
      './api/mocks/browser'
    );
    await worker.start({
      onUnhandledRequest: failOnUnhandledApiRequest,
    });
  }

  if (!i18n.isInitialized) {
    initI18n({
      lng: 'da',
      resources,
    });
  }

  setTheme('kunde');

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();
